import React from "react";
import style from "./Admin_Dashboard.module.css";
import Sidebar from "../../Sidebar/Sidebar";
import Table from "../Table/Table";
import { Link } from "react-router-dom";
const Admin_Dashboard = () => {
  return (
    <>
      <div className="flex">
        <Sidebar />
        <div>
          <p className={`${style.header} px-12 pt-8`}>Welcome!</p>
          <div className={`flex gap-20 m-12`}>
            <div>
              <div className={`${style.block1}`}></div>
              <p className={`${style.blockHeader} ml-20 text-xs -mt-14`}>
                Total Students
              </p>
              <p className={`${style.blockMainHeader} ml-20 text-2xl`}>12345</p>
            </div>
            <div>
              <div className={`${style.block2}`}></div>
              <p className={`${style.blockHeader} ml-20 text-xs -mt-14`}>
                Existing Educators
              </p>
              <p className={`${style.blockMainHeader} ml-20 text-2xl`}>123</p>
            </div>
            <div>
              <div className={`${style.block3}`}></div>
              <p className={`${style.blockHeader} ml-20 text-xs -mt-14`}>
                Unverified Educators
              </p>
              <p className={`${style.blockMainHeader} ml-20 text-2xl`}>12</p>
            </div>
            <div>
              <div className={`${style.block4}`}></div>
              <p className={`${style.blockHeader} ml-20 text-xs -mt-14 `}>
                Negative reviews
              </p>
              <p className={`${style.blockMainHeader} ml-20 text-2xl`}>40</p>
            </div>
          </div>

          <div className="m-8">
            <p className={`${style.title}`}>Course Statistics</p>
          </div>

          <div className="ml-11">
            <Table />
          </div>
          <div
            className={`${style.btns} flex justify-center mt-6 items-center gap-10`}
          >
            <div>
              <button className={`${style.btn1}`}>
                <Link to="/Exst_Edu">Educator</Link>
              </button>
            </div>
            <div>
              <button className={`${style.btn2}`}>
                <Link to="/Exst_Edu_Pro">Educator's Profile</Link>
              </button>
            </div>
            <div>
              <button className={`${style.btn3}`}>
                <Link to="/Edu_Validation">Educator Profile Validation</Link>
              </button>
            </div>
          </div>
        </div>

        <div>
          <div className={`${style.search}`}></div>
          <div className={`${style.secondaryTable} `}>
            <div>
              <p className={`${style.stHeader} border-b-2 border-gray p-4`}>
                Star Stastistic
              </p>
            </div>
            <div className={`${style.tbody}`}>
              <div>
                <div className="pl-4 pt-4">
                  <p className={`${style.student}`}>Students:</p>
                  <p className={`${style.watch}`}>Max Watch Hours:</p>
                </div>

                <div className="pl-4">
                  <div className={style.details}>
                    <p> Virat Sharan - 48hrs </p>
                    <p> Leela Ram - 42hrs </p>
                    <p> Shantanu Singh - 38hrs </p>
                  </div>
                </div>
                <div className="pl-4 pt-4">
                  <p className={`${style.student}`}>Teacher:</p>
                  <p className={`${style.watch}`}>Max Watch Hours:</p>
                </div>

                <div className="pl-4">
                  <div className={style.details}>
                    <p> Veer Sharan - 48hrs </p>
                    <p> Ram Ram - 42hrs </p>
                    <p> Vivek Singh - 38hrs </p>
                  </div>
                </div>

                <div className="pl-4 pt-4">
                  <div>
                    <p className={`${style.watch}`}>Max rating:</p>
                  </div>
                  <div className={style.details}>
                    <p>Prof. Dheeraj - 4.5</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin_Dashboard;
